
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Comment est-il administré?`}</em></p>
    <p>{`Deux doses sont injectées, avec un intervalle d'au moins trois semaines.`}</p>
    <p>{`Le 26 octobre, Swissmedic a annoncé que la
`}<a parentName="p" {...{
        "href": "638321504221"
      }}>{`troisième dose de rappel`}</a>{` (ou booster en anglais) avait été
autorisée pour les personnes vulnérables. Celle-ci est recommandée aux plus de
65 ans, en particulier ceux qui vivent en EMS ou qui souffrent d'autres maladies
graves.`}</p>
    <p>{`Ce rappel peut être administré au plus tôt six mois après la vaccination de
base. Il ne doit pas être confondu avec la troisième dose injectée aux personnes
immunodéprimées (par exemple en raison d'un cancer ou d'une greffe d'organe).
Ces patients-là n'ont pas ou peu développé d'immunité après les deux premières
doses et une injection supplémentaire est possible vingt-huit jours plus tard.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;